var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "bg-FF p-16 m-b-12 b-r-8" }, [
        _c(
          "div",
          { staticClass: "flex space-between col-center p-b-16" },
          [
            _c("TitleLogo"),
            _c("span", { staticClass: "font-32 font-weight-500" }, [
              _vm._v("拜访统计"),
            ]),
          ],
          1
        ),
        _c("div", { staticClass: "flex row-between p-b-20" }, [
          _c(
            "div",
            {
              staticClass:
                "width-49 bg-C8FFFD b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24",
            },
            [
              _vm._m(0),
              _c("div", [
                _c("div", { staticClass: "font-40 font-weight-700" }, [
                  _vm._v(_vm._s(_vm.boardData.visit?.visitCompanyNum)),
                ]),
                _c("div", { staticClass: "font-24" }, [_vm._v("拜访客户数")]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "width-49 bg-FFEDCF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24",
            },
            [
              _vm._m(1),
              _c("div", [
                _c("div", { staticClass: "font-40 font-weight-700" }, [
                  _vm._v(_vm._s(_vm.boardData.visit?.visitCustomerNum)),
                ]),
                _c("div", { staticClass: "font-24" }, [_vm._v("拜访联系人")]),
              ]),
            ]
          ),
        ]),
        _c("div", { staticClass: "font-28 text-center" }, [
          _vm._v(" 共拜访"),
          _c("span", { staticClass: "font-weight-700" }, [
            _vm._v(_vm._s(_vm.boardData.visit?.visitNum)),
          ]),
          _vm._v("次，在" + _vm._s(_vm.boardData?.unitUserNum) + "人中排名第"),
          _c("span", { staticClass: "font-weight-700" }, [
            _vm._v(_vm._s(_vm.boardData.visit?.visitRank)),
          ]),
        ]),
      ]),
      _c("ContractCarousel", {
        attrs: {
          carouselData: _vm.boardData.contractList,
          bgImg: _vm.contractBgImg,
          type: 1,
        },
      }),
      _c("ContractCarousel", {
        attrs: {
          carouselData: _vm.boardData.receiveList,
          bgImg: _vm.paymentCollectionBgImg,
          type: 2,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-72 h-72 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "反馈次数",
          src: require("@/assets/icon/employeeKanban/fankui.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-72 h-72 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "未反馈",
          src: require("@/assets/icon/employeeKanban/weifankui.png"),
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }